export interface Topic {
  id: string;
  title: string;
  description: string;
  event: string;
  count: number;
  cover: string;
}

export const topics: Topic[] = [
  {
    id: 'tp-01',
    title: '今日黑榜深度复盘',
    description: '每天更新各大赛事黑榜选手的表现数据与失误解析，帮助你快速掌握排名变化的真实原因。',
    event: '全站专题',
    count: 6,
    cover:
      'https://readdy.ai/api/search-image?query=Analytical%20esports%20review%20scene%20with%20multiple%20screens%20showing%20player%20statistics%2C%20deep%20blue%20ambient%20light%20with%20orange%20data%20highlights%2C%20professional%20broadcast%20mood%2C%20high%20detail%20editorial%20photography&width=600&height=400&seq=tp-01-cover&orientation=landscape',
  },
  {
    id: 'tp-02',
    title: '星轨联赛争冠之路',
    description: '聚焦星轨联赛积分榜前四的强强对话，跟踪每一场关键比赛的排名变化与战术博弈。',
    event: '星轨联赛',
    count: 4,
    cover:
      'https://readdy.ai/api/search-image?query=Championship%20trophy%20on%20a%20dark%20stage%20with%20deep%20blue%20lighting%20and%20warm%20orange%20spotlights%2C%20esports%20grand%20final%20atmosphere%2C%20cinematic%20hero%20shot%2C%20high%20detail%20editorial%20photography&width=600&height=400&seq=tp-02-cover&orientation=landscape',
  },
  {
    id: 'tp-03',
    title: '新赛制观察',
    description: '雷霆竞技场与极光杯规则调整后的连锁反应，解读节奏加快对各支战队与选手的影响。',
    event: '雷霆竞技场',
    count: 3,
    cover:
      'https://readdy.ai/api/search-image?query=Rule%20change%20and%20strategy%20board%20visualization%20in%20a%20modern%20sports%20analysis%20room%2C%20deep%20blue%20background%20with%20orange%20diagram%20lines%2C%20tactical%20analytical%20mood%2C%20high%20detail%20editorial%20photography&width=600&height=400&seq=tp-03-cover&orientation=landscape',
  },
  {
    id: 'tp-04',
    title: '新人崛起档案',
    description: '盘点本赛季冉冉升起的新人选手，用数据记录他们的成长曲线与高光时刻。',
    event: '选手动态',
    count: 5,
    cover:
      'https://readdy.ai/api/search-image?query=Young%20rising%20esports%20players%20training%20in%20a%20bright%20arena%2C%20deep%20blue%20tones%20with%20energetic%20orange%20accents%2C%20hopeful%20growth%20atmosphere%2C%20high%20detail%20editorial%20photography&width=600&height=400&seq=tp-04-cover&orientation=landscape',
  },
];